import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { verifyEmail } from "../_redux/authCrud";

// Reached via the link emailed at registration (or resend). Public - the
// user is not necessarily logged in yet at this point.
export default function VerifyEmail(props) {
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = props.match && props.match.params && props.match.params.token;
    if (!token) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }

    verifyEmail(token)
      .then(() => setStatus("success"))
      .catch(err => {
        setStatus("error");
        setMessage(
          (err.response && err.response.data) ||
            "This verification link is invalid or has expired."
        );
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="login-form" style={{ display: "block" }}>
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">Email Verification</h3>
      </div>

      {status === "verifying" && (
        <div className="text-center text-muted">Verifying your email address...</div>
      )}

      {status === "success" && (
        <div className="alert alert-custom alert-light-success fade show mb-10" role="alert">
          <div className="alert-icon">
            <span className="svg-icon svg-icon-3x svg-icon-success">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")} />
            </span>
          </div>
          <div className="alert-text font-weight-bold">
            Your email has been verified. You can now log in.
          </div>
        </div>
      )}

      {status === "error" && (
        <div className="alert alert-custom alert-light-danger fade show mb-10" role="alert">
          <div className="alert-icon">
            <span className="svg-icon svg-icon-3x svg-icon-danger">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")} />
            </span>
          </div>
          <div className="alert-text font-weight-bold">
            {typeof message === "string" ? message : JSON.stringify(message)}
            <div className="mt-4">
              <Link to="/auth/resend-verification" className="font-weight-bold">
                Resend verification email
              </Link>
            </div>
          </div>
        </div>
      )}

      <div className="form-group d-flex flex-wrap flex-center mt-6">
        <Link to="/auth/login">
          <button type="button" className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4">
            Go to Login
          </button>
        </Link>
      </div>
    </div>
  );
}
